import { useApplicationUrl } from '@api/hooks/useApplicationUrl';
import { toastError } from '@components/Toast/Toast';
import { useBankProfile } from '@contexts/BankProfileContext.tsx';
import { Application } from '@gurupay/gp-ui-library';
import type { FC } from 'react';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

export const OddButton: FC = () => {
	const { t } = useTranslation();
	const { selectedProfile } = useBankProfile();
	const { mutateAsync: fetchApplicationUrl, isPending } = useApplicationUrl();

	const goToApplication = useCallback(async () => {
		const oddTab = window.open('about:blank', '_blank');
		try {
			const { redirect_url } = await fetchApplicationUrl();
			if (oddTab) {
				oddTab.location.href = redirect_url;
			}
		} catch {
			oddTab?.close();
			toastError(t('layout.controlPanel.applicationError'));
		}
	}, [fetchApplicationUrl, t]);

	if (!selectedProfile?.odd_eligible) return null;

	return (
		<button
			className="w-full flex items-center text-sm-medium gap-space-8 p-space-4 transition-all duration-200 ease-linear text-neutral-800 hover:text-neutral-950 rounded-sm cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
			disabled={isPending}
			onClick={goToApplication}
		>
			<Application className="w-space-32 h-space-32 p-space-4 rounded-sm transition-all duration-200 ease-linear" />
			<span className="text-left flex-grow">{t('layout.controlPanel.application')}</span>
			<span className="leading-6 text-white bg-neutral-950 rounded-full w-space-24 h-space-24">
				!
			</span>
		</button>
	);
};
